import { useContext, useState } from "react";
import Button from "../../atoms/button";
import SelectModel from "./selectModel";
import { createSerialDraft } from "../functions";
import ToastContext from "../../../context/toastProvider";
import LoadingOverlay from "../../atoms/loadingOverlay";
import AutographNoteSelect from "../AutographNoteSelect";
import { gradingTypeSupportsGeneralScore, gradingTypeSupportsSubgrades } from "../../utils/gradingTypes";

const NewSerial = ({ user, product, refresh }) => {

    const { goodToast, badToast } = useContext(ToastContext);

    const [model, setModel] = useState(null);
    const [modal, setModal] = useState(false);

    const [generalScore, setGeneralScore] = useState("");
    const [surface, setSurface] = useState("");
    const [edges, setEdges] = useState("");
    const [centering, setCentering] = useState("");
    const [corners, setCorners] = useState("");
    const [notaAutografo, setNotaAutografo] = useState("");
    const [loading, setLoading] = useState(false);

    const supportsGeneralScore = gradingTypeSupportsGeneralScore(product?.gradingType);
    const supportsSubgrades = gradingTypeSupportsSubgrades(product?.gradingType, product?.preLacreFormat);
    const supportsAutographNote = product?.autographEvaluation === true;
    const disableSave = !model || (supportsGeneralScore && generalScore === "") || (supportsSubgrades && (surface === "" || edges === "" || centering === "" || corners === "")) || (supportsAutographNote && notaAutografo === "");

    // const handleGeneralScore = (value) => {
    //     if (value.includes(",") && value.includes(".")) {
    //         return null;
    //     }
    //     if(parseFloat(value.replace(",", ".")) > 10){
    //         return null;
    //     }
    //     if (isNumeric(value) || isNumeric(value.replace(",", "").replace(".", ""))) {
    //         setGeneralScore(value);
    //     }
    // }

    const doCreateSerial = async () => {
        setLoading(true);
        const body = {
            gradableModelId: model?._id,
            ...(supportsGeneralScore ? { generalScore } : {}),
            ...(supportsSubgrades ? { surface, edges, centering, corners } : {}),
            ...(supportsAutographNote ? { notaAutografo } : {}),
            productId: product?._id
        }
        const serialResponse = await createSerialDraft(user?.token, product?._id, body);
        if(serialResponse?.type === "success"){
            goodToast(serialResponse?.message);
            setLoading(false);
            refresh();
            return null;
        }
        badToast(serialResponse?.message);
        setLoading(false);
    }

    // const addSerial = () => {
    //     const body = {
    //         gradableModel: {
    //             game: model?.game,
    //             name: model?.name,
    //             edition: model?.edition,
    //             numbering: model?.numbering,
    //             rarity: model?.rarity,
    //             language: model?.language,
    //             year: model?.year
    //         },
    //         gradableModelId: model?._id,
    //         generalScore,
    //         surface,
    //         edges,
    //         centering,
    //         corners,
    //         productId: product?._id,
    //         new: true,
    //         rId: generateRandomID()
    //     }
    //     setProductSerials(ps => [body, ...ps]);
    //     setCentering("");
    //     setCorners("");
    //     setEdges("");
    //     setGeneralScore("");
    //     setSurface("");
    //     setModel(null);
    // }

    return (
        <div className="border border-primary p-2 bg-black mb-4 relative">
            <div className="flex justify-evenly items-end">
                <div className="w-40">
                    <p className="m-0 text-sm text-[#999] text-center">Jogo</p>
                    <p style={{ color: model?.game ? "#ffedd5" : "#666" }} title={model?.game} className="border border-[#666] px-2 py-1 text-center">{model?.game || "Jogo"}</p>
                </div>
                <div className="w-40">
                    <p className="m-0 text-sm text-[#999] text-center">Nome</p>
                    <p style={{ color: model?.name ? "#ffedd5" : "#666" }} title={model?.name} className="border border-[#666] px-2 py-1 text-center">{model?.name || "Name"}</p>
                </div>
                <div className="w-40">
                    <p className="m-0 text-sm text-[#999] text-center">Edição</p>
                    <p style={{ color: model?.edition ? "#ffedd5" : "#666" }} title={model?.edition} className="border border-[#666] px-2 py-1 text-center">{model?.edition || "Edição"}</p>
                </div>
                <div className="w-40">
                    <p className="m-0 text-sm text-[#999] text-center">Numeração</p>
                    <p style={{ color: model?.numbering ? "#ffedd5" : "#666" }} title={model?.numbering} className="border border-[#666] px-2 py-1 text-center">{model?.numbering || "Numeração"}</p>
                </div>
                <div className="w-40">
                    <Button click={() => setModal(true)} classes="bg-primary mb-2">{!model ? "Selecionar modelo" : "Alterar modelo"}</Button>
                </div>
                {
                    modal ?
                        <SelectModel setModel={setModel} user={user} close={() => setModal(false)} />
                        : null
                }
            </div>
            <div className="flex justify-evenly items-end mt-4">
                {
                    supportsGeneralScore ?
                        <div className="w-40">
                            <p className="m-0 text-sm text-[#999] text-center">Nota Geral</p>
                            <input value={generalScore} onChange={e => setGeneralScore(e.target.value)} type="text" className="border border-[#666] bg-transparent m-auto w-full px-2 py-1 text-center" />
                        </div>
                        : null
                }
                {
                    supportsSubgrades ?
                        <>
                            <div className="w-40">
                                <p className="m-0 text-sm text-[#999] text-center">Surface</p>
                                <input value={surface} onChange={e => setSurface(e.target.value)} type="text" className="border border-[#666] bg-transparent m-auto w-full px-2 py-1 text-center" />
                            </div>
                            <div className="w-40">
                                <p className="m-0 text-sm text-[#999] text-center">Edges</p>
                                <input value={edges} onChange={e => setEdges(e.target.value)} type="text" className="border border-[#666] bg-transparent m-auto w-full px-2 py-1 text-center" />
                            </div>
                            <div className="w-40">
                                <p className="m-0 text-sm text-[#999] text-center">Centering</p>
                                <input value={centering} onChange={e => setCentering(e.target.value)} type="text" className="border border-[#666] bg-transparent m-auto w-full px-2 py-1 text-center" />
                            </div>
                            <div className="w-40">
                                <p className="m-0 text-sm text-[#999] text-center">Corners</p>
                                <input value={corners} onChange={e => setCorners(e.target.value)} type="text" className="border border-[#666] bg-transparent m-auto w-full px-2 py-1 text-center" />
                            </div>
                        </>
                        : null
                }
                {
                    supportsAutographNote ?
                        <div className="w-40">
                            <p className="m-0 text-sm text-[#999] text-center">Nota do Autografo</p>
                            <AutographNoteSelect value={notaAutografo} onChange={setNotaAutografo} className="border border-[#666] bg-transparent m-auto w-full px-2 py-1 text-center" />
                        </div>
                        : null
                }
                <div className="w-40">
                    <Button disabled={disableSave} click={doCreateSerial} classes="bg-green-500 hover:bg-green-300 mb-2">Salvar</Button>
                </div>
            </div>
            <LoadingOverlay loading={loading}/>
        </div>
    )
}

export default NewSerial;
